module.exports = __webpack_public_path__ + "img/bg-document-2.27e6a3aa.png";